export default __webpack_public_path__ + "static/media/ca-bc.2558b0f2.svg";